import { motion } from "framer-motion";
import { Bot, Users, Presentation, Gift } from "lucide-react";
import ApplyCta from "./ApplyCta";

const bonuses = [
  {
    number: "1",
    icon: Bot,
    title: "Agente de IA · Custodia de Marca",
    description: "Sistema interno que resguarda criterios estratégicos y evita la dependencia de proveedores externos.",
  },
  {
    number: "2",
    icon: Users,
    title: "Sesión Estratégica con el Equipo",
    description: "Alineación interna para sostener la identidad sin fricción.",
  },
  {
    number: "3",
    icon: Presentation,
    title: "Presentación Técnica de Marca",
    description: "Transferencia clara para asegurar correcta implementación y mantenimiento.",
  },
];

const ServiceBonuses = () => {
  return (
    <section id="bonos" className="py-20 md:py-28 relative overflow-hidden bg-background">
      <div className="container px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-primary/30 bg-primary/5 mb-6">
            <Gift className="w-4 h-4 text-primary" />
            <span className="font-medium text-primary text-sm">Bonus Exclusivos</span>
          </div>
          
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            Herramientas de <span className="text-gradient-gold">Implementación</span>
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Para que la marca se sostenga más allá del proceso.
          </p>
        </motion.div>

        {/* Bonuses Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {bonuses.map((bonus, index) => (
            <motion.div
              key={bonus.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="group relative"
            >
              <div className="bg-card rounded-2xl p-8 h-full transition-all duration-500 hover:border-primary/50 hover:shadow-lg border border-border relative overflow-hidden">
                {/* Bonus number */}
                <div className="absolute top-4 right-4 text-6xl font-display font-bold text-primary/10">
                  {bonus.number}
                </div>
                
                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-[#7ab7fd] flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-[#7ab7fd]/30">
                  <bonus.icon className="w-7 h-7 text-[#0a162a]" />
                </div>

                {/* Content */}
                <h3 className="font-display text-xl font-semibold mb-3">
                  {bonus.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {bonus.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
        <ApplyCta />
      </div>
    </section>
  );
};

export default ServiceBonuses;
